<template>
  <div class="report">
    <div class="report-tools">
      <div class="report-tools__filters">
        <report-dates v-if="report.datesSelect" />
        <report-parent v-if="report.parentSelect" />
        <report-performer v-if="report.performerSelect" />
        <report-status v-if="report.statusSelect" />
        <object-status v-if="!!report.statusField" :type="report.statusField" />
        <report-manager v-if="report.managerSelect" type="manager" />
        <report-manager v-if="report.fieldManagerSelect" type="field_managers" />
        <report-errors v-if="report.onlyErrorSetting" />
      </div>

      <div class="report-tools__right">
        <i-button
          v-if="report.downloadFiles"
          class="export-documents"
          @click="downloadFiles"
          type="primary"
        >
          Скачать документы
        </i-button>
        <i-button
          class="export-table-button"
          @click="exportTable"
          type="success"
        >
          Экспорт таблицы
        </i-button>
      </div>
    </div>
    <div :class="`report-content ${report.id}`">
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить выбранный Вами отчет. Повторите, пожалуйста,
        попытку позже
      </div>
      <template v-else>
        <i-table
          ref="reportTable"
          no-data-text="Отчет пуст"
          border
          :columns="columns"
          :data="filteredData"
          :disabled-hover="true"
          size="small"
          :show-summary="!!report.summaryColumns"
          :summary-method="handleSummary"
          :height="maxTableHeight"
        >
          <template slot-scope="{ row }" slot="action">
            <i-button
              type="primary"
              shape="circle"
              icon="md-create"
              @click="editContract(row)"
            />
          </template>
        </i-table>

        <div class="report-pagination">
          <page
            :total="total"
            :current="current"
            :page-size="count"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
            show-sizer
            :page-size-opts="pageSizes"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ReportDates from '@/components/reports/report-dates'
import ReportStatus from '@/components/reports/report-status'
import ObjectStatus from '@/components/reports/object-status'
import ReportParent from '@/components/reports/report-parent'
import ReportPerformer from '@/components/reports/report-performer'
import ReportErrors from '@/components/reports/report-errors'
import ReportManager from '@/components/reports/report-manager'
import InlineLoader from '@/components/loaders/inline-loader'
import {
  reportsList,
  reportsConfigs,
  modifyData,
  getAdditionalFilesColumns
} from '@/config/reports'
import { mainUrl } from '@/config/urls'
import { downloadFile, getSummaryRow, getActualHeight } from '@/utils'

export default {
  components: {
    ReportDates,
    ReportStatus,
    ObjectStatus,
    ReportParent,
    ReportPerformer,
    ReportErrors,
    ReportManager,
    InlineLoader
  },
  data () {
    return {
      maxTableHeight: 640,
      reportData: [],
      token: this.$store.state.auth.token,
      loading: false,
      nodata: false,
      current: 1,
      count: 15,
      total: 20,
      pageSizes: [15, 25, 40],
      reportsConfigs
    }
  },
  computed: {
    report () {
      const { id } = this.$route.params

      return reportsList.find(r => r.id === id)
    },
    columns () {
      if (this.report.id === 'report_7') {
        return getAdditionalFilesColumns(this.reportData)
      }

      return this.reportsConfigs[this.report.id]
    },
    filteredData () {
      const currentIndex = (this.current - 1) * this.count

      return this.reportData.slice(currentIndex, currentIndex + this.count)
    }
  },
  watch: {
    '$route.params.id' () {
      this.getData()
      this.changeTableHeight()
    },
    '$store.state.filters.company' () {
      this.getData()
    },
    '$store.state.reports.parent' () {
      this.getData()
    },
    '$store.state.reports.performer' () {
      this.getData()
    },
    '$store.state.reports.startDate' () {
      this.getData()
    },
    '$store.state.reports.endDate' () {
      this.getData()
    },
    '$store.state.reports.status' () {
      this.getData()
    },
    '$store.state.reports.objectStatus' () {
      this.getData()
    },
    '$store.state.reports.onlyError' () {
      this.getData()
    },
    '$store.state.reports.manager' () {
      this.getData()
    },
    '$store.state.reports.field_managers' () {
      this.getData()
    }
  },
  methods: {
    getUrlWithFilters (url) {
      const { reports, filters } = this.$store.state
      const { company } = filters
      const {
        startDate,
        endDate,
        status,
        objectStatus,
        parent,
        performer,
        onlyError,
        manager,
        field_managers
      } = reports
      const start = moment(startDate).format('DD.MM.YYYY')
      const end = moment(endDate).format('DD.MM.YYYY')

      if (this.report.datesSelect) {
        url += `&date=${start}/${end}`
      }

      if (this.report.companySelect) {
        url += `&company=${company}`
      }

      if (this.report.statusSelect) {
        const value = typeof status === 'string' ? status : status.join(',')
        url += `&status=${value}`
      }

      if (this.report.statusField && objectStatus !== 'all') {
        url += `&${this.report.statusField}_status=${objectStatus}`
      }

      if (this.report.parentSelect && parent !== 'all') {
        url += `&parent=${parent}`
      }

      if (this.report.performerSelect && performer !== 'all') {
        url += `&performer=${performer}`
      }

      if (this.report.onlyErrorSetting) {
        url += `&only_error=${onlyError}`
      }

      if (this.report.managerSelect) {
        url += `&managers=${manager.join(',')}`
      }

      if (this.report.fieldManagerSelect) {
        url += `&field_managers=${field_managers.join(',')}`
      }

      return url
    },
    exportTable () {
      const baseUrl = `page/${this.report.url}`
      let url = `${mainUrl}/api/${baseUrl}format=excel&access_token=${
        this.token
      }`

      const urlWithFilters = this.getUrlWithFilters(url)

      downloadFile(urlWithFilters)
    },
    downloadFiles () {
      const baseUrl = `page/${this.report.url}`
      let url = `${mainUrl}/api/${baseUrl}format=files&access_token=${
        this.token
      }`

      const urlWithFilters = this.getUrlWithFilters(url)

      downloadFile(urlWithFilters)
    },
    async getData () {
      if (this.loading) return

      try {
        this.nodata = false
        this.loading = true

        const url = `page/${this.report.url}`
        const urlWithFilters = this.getUrlWithFilters(url)

        const data = await this.$store.dispatch('GET_REQUEST', {
          url: urlWithFilters
        })
        const parsedData = typeof data === 'string' ? JSON.parse(data) : data

        this.reportData = modifyData(this.report.id, parsedData)
        this.total = this.reportData.length
        this.current = 1

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    handleSummary (payload) {
      const columns = this.report.summaryColumns

      return getSummaryRow(payload, columns)
    },
    changeTableHeight () {
      const height = getActualHeight()

      this.maxTableHeight = height - 288

      if (this.report.summaryColumns) this.maxTableHeight -= 40
    },
    editContract ({ contract_id, id }) {
      this.$store.commit('SET_COME_FROM', null)

      const route = this.$router.resolve({
        path: `/app/contracts/${contract_id || id}/overview`
      })

      window.open(route.href, '_blank')
    },
    changePage (page) {
      this.current = page
    },
    changePageSize (size) {
      this.count = size
    }
  },
  created () {
    this.getData()

    this.changeTableHeight()
    window.addEventListener('resize', this.changeTableHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.changeTableHeight)
  }
}
</script>

<style lang="less">
.report {
  &-tools {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &__filters {
      display: flex;
      flex-wrap: wrap;
      column-gap: 24px;
      row-gap: 16px;

      .report-filter {
        flex-shrink: 0;
      }
    }

    &__right {
      margin-left: auto;
    }

    .export-documents {
      margin-right: 16px;
    }
  }

  .ivu-table {
    &-cell {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      word-break: break-word;
      white-space: pre-line;
    }

    .reports-files {
      &-col {
        height: 100% !important;
        position: relative;

        .ivu-table-cell {
          padding: 0 !important;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
      }

      &-cell {
        width: 100%;
        height: 100%;

        &-true {
          background-color: rgba(183, 235, 143, 0.1);
          color: rgb(183, 235, 143);

          span {
            margin-top: -4px;
            margin-left: 1px;
          }
        }

        &-false {
          background-color: rgba(255, 163, 158, 0.1);
          color: rgb(255, 163, 158);

          span {
            margin-top: -3px;
            margin-left: 1px;
          }
        }
      }
    }

    th.reports-files-col {
      .ivu-table-cell {
        padding: 8px !important;
        position: static;
      }
    }
  }

  .report_7 {
    td {
      height: 120px !important;
    }

    td.reports-files-name {
      .ivu-table-cell span {
        width: 200px !important;
        height: 104px;
        display: block;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &-pagination {
    margin-top: 16px;
    display: flex;
    justify-content: center;
  }
}

.light {
  .reports-files-cell {
    &-true {
      color: rgb(82, 196, 26) !important;
      background-color: rgba(82, 196, 26, 0.1) !important;
    }

    &-false {
      color: rgb(250, 84, 28) !important;
      background-color: rgba(250, 84, 28, 0.1) !important;
    }
  }
}
</style>
